import React from 'react';
import { Box, Container } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import GlobalNavigation from '../common/GlobalNavigation';
import DashboardPage from '../dashboard/DashboardPage';
import SettingsPage from '../settings/SettingsPage';
import DisbursementsPage from '../disbursements/DisbursementsPage';
import TransactionsPage from '../transactions/TransactionsPage';
import LoginPage from '../auth/LoginPage';
import { useAuth } from '../../hooks/useAuth';

const MainLayout: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', pt: '50px' }}>
      <GlobalNavigation />
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Routes>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/disbursements" element={<DisbursementsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Container>
    </Box>
  );
};

export default MainLayout; 